import { useState, useEffect } from 'react';
import api from '../utils/axios';

const usePieChartData = () => {
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const fetchData = async () => {
			try {
				setLoading(true); // Устанавливаем состояние загрузки в true перед началом запроса
				const response = await api.get('/marks-info');
				setData(response.data);
			} catch (error) {
				setError(error);
			} finally {
				setLoading(false); // Устанавливаем состояние загрузки в false после завершения запроса
			}
		};

		fetchData(); // Initial fetch

		// const intervalId = setInterval(fetchData, 10000); // Запускаем запрос каждые 3 секунды

		// return () => clearInterval(intervalId); // Очистка интервала при размонтировании компонента
	}, []); // Зависимости пустые, чтобы эффект выполнялся только при монтировании

	return { data, loading, error };
};

export default usePieChartData;
